import { SlingoModel } from "@lib/titan2-slingo/dist/game/model/SlingoModel";
import { FishFoodChanceGameData, GoldFishChanceGameData, GreenFishChanceGameData, PurpleFishChanceGameData, RedFishChanceGameData } from "./data/ChanceGamesData";
import { featureTypeFromChanceGameConfigId, featureTypeFromChanceGameConfigIdStrict } from "./response/data/featureTypeFromChanceGameConfigId";
/**
 * GameModel.ts
 */
export class GameModel extends SlingoModel {
    constructor() {
        super();
        this.TICKET_DAB_TIMEOUT = 1;
    }
    addUserchoice(choice) {
        this.userChoices.push(choice);
    }
    setUserChoices(choices) {
        this.userChoices = choices.slice();
    }
    consumeNextUserChoice() {
        if (!this.userChoices || !this.userChoices.length) {
            return null;
        }
        return this.userChoices.shift();
    }
    getUserChoices() {
        return this.userChoices;
    }
    reset() {
        super.reset();
        this.featureType = FeatureType.NONE;
        this.featureState = FeatureStateType.DISABLED;
        this.slotsGameData = null;
        this.slotsSpinsTotal = 0;
        this.slotsSpinsRemaining = 0;
        this.featureSpinsRemaining = 0;
        this.slotsSpins = [];
        this.slotsSpinsIndex = -1;
        this.ticketDabsInProgress = [];
        this.winningPatternPlayed = 0;
        this.FreeSpinReelState = FreeSpinReelState.STANDARD_REEL;
        this.userChoices = [];
    }
    getFreeSpinReelState() {
        return this.FreeSpinReelState;
    }
    getBasePayout(matchedPatterns) {
        const prizeconfigs = this.currentGame?.getConfig()?.getPrizeConfig();
        let prizeConfig;
        if (prizeconfigs && prizeconfigs.length) {
            prizeConfig = prizeconfigs.find(config => config.getPattern() === matchedPatterns);
        }
        return prizeConfig?.getBasePayout() || 0;
    }
    getReelDisplayData() {
        return this.reelDisplayData;
    }
    getChanceGameData() {
        return this.chanceGameData;
    }
    getGreenFishChanceGameData() {
        const chanceGameData = this.getChanceGameData();
        if (!chanceGameData || !(chanceGameData instanceof GreenFishChanceGameData)) {
            console.error(chanceGameData);
            throw new Error("Missing or incorrect chanceGameData");
        }
        return chanceGameData;
    }
    getRedFishChanceGameData() {
        const chanceGameData = this.getChanceGameData();
        if (!chanceGameData || !(chanceGameData instanceof RedFishChanceGameData)) {
            console.error(chanceGameData);
            throw new Error("Missing or incorrect chanceGameData");
        }
        return chanceGameData;
    }
    getPurpleFishChanceGameData() {
        const chanceGameData = this.getChanceGameData();
        if (!chanceGameData || !(chanceGameData instanceof PurpleFishChanceGameData)) {
            console.error(chanceGameData);
            throw new Error("Missing or incorrect chanceGameData");
        }
        return chanceGameData;
    }
    getFishFoodChanceGameData() {
        const chanceGameData = this.getChanceGameData();
        if (!chanceGameData || !(chanceGameData instanceof FishFoodChanceGameData)) {
            console.error(chanceGameData);
            throw new Error("Missing or incorrect chanceGameData");
        }
        return chanceGameData;
    }
    getGoldFishChanceGameData() {
        const chanceGameData = this.getChanceGameData();
        if (!chanceGameData || !(chanceGameData instanceof GoldFishChanceGameData)) {
            console.error(chanceGameData);
            throw new Error("Missing or incorrect chanceGameData");
        }
        return chanceGameData;
    }
    getFeatureState() {
        return this.featureState;
    }
    setFeatureState(val) {
        this.featureState = val;
    }
    getFeatureWheelWin() {
        return this.chanceGameData?.getTotalWin() || 0;
    }
    getFeatureSlotsWin() {
        return this.slotsGameData?.getTotalWin() || 0;
    }
    setFreeSpinReelState(val) {
        this.FreeSpinReelState = val;
    }
    setFeatureType(val) {
        this.featureType = val;
    }
    getFeatureType() {
        return this.featureType;
    }
    setChanceGamesData(val) {
        this.chanceGameData = val;
    }
    setSlotsGameData(val) {
        this.slotsGameData = val;
    }
    getSlotsGameData() {
        return this.slotsGameData;
    }
    getSpinResult() {
        return this.spinResult;
    }
    setFeatureSpinsRemaining(val) {
        this.featureSpinsRemaining = val;
    }
    getFeatureReelTotalColumns() {
        return this.featureReelTotalColumns;
    }
    setFeatureReelTotalColumns(val) {
        this.featureReelTotalColumns = val;
    }
    getFeatureReelTotalRows() {
        return this.featureReelTotalRows;
    }
    setFeatureReelTotalRows(val) {
        this.featureReelTotalRows = val;
    }
    decrementFeatureSpinsRemaining() {
        this.featureSpinsRemaining--;
        return this.featureSpinsRemaining;
    }
    getFeatureSpinsRemaining() {
        return this.featureSpinsRemaining;
    }
    getFeatureSlotsStake() {
        return this.slotsGameData?.getTotalStake() || 0;
    }
    getFeatureTotalWin() {
        return this.getFeatureSlotsWin(); // updated maths - chancegameData should now contain slots win
    }
    setSlotsSpins(slotsSpins) {
        this.slotsSpins = slotsSpins?.slice();
    }
    getSlotsSpinsTotal() {
        return this.slotsSpinsTotal;
    }
    setSlotsSpinsTotal(val) {
        this.slotsSpinsTotal = val;
    }
    getSlotsSpinsRemaining() {
        return this.slotsSpinsRemaining;
    }
    setSlotsSpinsRemaining(val) {
        this.slotsSpinsRemaining = val;
    }
    nextSlotsSpin() {
        this.slotsSpinsIndex++;
    }
    getSlotsSpinsIndex() {
        return this.slotsSpinsIndex;
    }
    getCurrentSlotsSpin() {
        return this.slotsSpins?.length ? this.slotsSpins[this.slotsSpinsIndex] : undefined;
    }
    getPreviousSlotsSpin() {
        return this.slotsSpins?.length ? this.slotsSpins[this.slotsSpinsIndex - 1] : undefined;
    }
    getNextSlotsSpin() {
        return this.slotsSpins?.length ? this.slotsSpins[this.slotsSpinsIndex + 1] : undefined;
    }
    getCurrentSlotsWin() {
        if (this.slotsSpins?.length) {
            return this.slotsSpins.slice(0, this.slotsSpinsIndex + 1).map((spin) => spin.getTotalWin()).reduce((acc, curr) => acc + curr, 0);
        }
        return 0;
    }
    getSlotSpins() {
        return this.slotsSpins;
    }
    setTicketDabInProgress(ticketSymbol) {
        this.ticketDabsInProgress.push(ticketSymbol);
    }
    setTicketDabComplete(ticketSymbol) {
        const index = this.ticketDabsInProgress.indexOf(ticketSymbol);
        if (index > -1) {
            this.ticketDabsInProgress.splice(index, 1);
        }
    }
    getWinnigPatternsPlayed() {
        return this.winningPatternPlayed;
    }
    setWinningPatternsPlayed(value) {
        this.winningPatternPlayed = value;
    }
    isBigWin() {
        return false;
    }
    isHugeWin() {
        return false;
    }
    isMegaWin() {
        return false;
    }
    isWin() {
        return this.getTotalWin() > this.getTotalStaked();
    }
    isTicketDabInProgress() {
        return this.ticketDabsInProgress.length > 0;
    }
    featureTypeFromChanceGameConfigId(gameConfigId) {
        return featureTypeFromChanceGameConfigId(gameConfigId);
    }
    featureTypeFromMatches(matches) {
        switch (matches) {
            case 5:
                return FeatureType.GREEN_FISH;
            case 6:
                return FeatureType.FISH_FOOD;
            case 7:
                return FeatureType.RED_FISH;
            case 8:
                return FeatureType.FISH_FOOD;
            case 9:
                return FeatureType.PURPLE_FISH;
            case 10:
                return FeatureType.GOLD_FISH;
            default:
                return FeatureType.NONE;
        }
    }
    testFeature(testData) {
        this.featureState = FeatureStateType.IN_PROGRESS;
        this.setSlotsGameData((testData.getSlotsGame()));
        this.setSlotsSpins(testData.getSlotsSpins());
        this.setChanceGamesData(testData.getChanceGame());
        const featureType = featureTypeFromChanceGameConfigIdStrict(testData.getChanceGame().getGameConfigId());
        this.setFeatureType(featureType);
    }
}
/**
 * FeatureStateType.ts
 */
export class FeatureStateType {
    constructor(type) {
        this.type = type;
    }
    static getType(type) {
        return FeatureStateType[type];
    }
    isDisabled() {
        return this.type === FeatureStateType.DISABLED.getType();
    }
    isEnabled() {
        return this.type === FeatureStateType.ENABLED.getType();
    }
    isCollected() {
        return this.type === FeatureStateType.COLLECTED.getType();
    }
    isInProgress() {
        return this.type === FeatureStateType.IN_PROGRESS.getType();
    }
    getType() {
        return this.type;
    }
}
FeatureStateType.DISABLED = new FeatureStateType("DISABLED");
FeatureStateType.ENABLED = new FeatureStateType("ENABLED");
FeatureStateType.COLLECTED = new FeatureStateType("COLLECTED");
FeatureStateType.IN_PROGRESS = new FeatureStateType("IN_PROGRESS");
/**
 * FeatureType.ts
 */
export var FeatureType;
(function (FeatureType) {
    FeatureType["NONE"] = "NONE";
    FeatureType["GREEN_FISH"] = "GREEN_FISH";
    FeatureType["RED_FISH"] = "RED_FISH";
    FeatureType["PURPLE_FISH"] = "PURPLE_FISH";
    FeatureType["GOLD_FISH"] = "GOLD_FISH";
    FeatureType["FISH_FOOD"] = "FISH_FOOD";
})(FeatureType || (FeatureType = {}));
export var FreeSpinReelState;
(function (FreeSpinReelState) {
    FreeSpinReelState["FREE_SPIN_REEL"] = "FreeSpinReelState.FREE_SPIN_REEL";
    FreeSpinReelState["TRANSITION_IN"] = "FreeSpinReelState.TRANSITION_IN";
    FreeSpinReelState["TRANSITION_OUT"] = "FreeSpinReelState.TRANSITION_OUT";
    FreeSpinReelState["STANDARD_REEL"] = "FreeSpinReelState.STANDARD_REEL";
})(FreeSpinReelState || (FreeSpinReelState = {}));
//# sourceMappingURL=GameModel.js.map